import React from 'react';
import LanguageComponent from '../../components/language-selector/language.component'
// images
const logo = require('../../images/logo_airportr.svg');
// styles
const styles = require('./tracking-timeline.scss');

export type languages = 'en' | 'fr' | 'de';

interface IState {
  language: string;
  showDetails: boolean;
  hasDowngradedBag: boolean;
  timelineBaseClass: string;
  timelineClasses: string;
  statusGroups: any;
}

interface IProps {
  language: string;
  languageCode: string;
  multiLang: any;
  handleLanguageChange: any;
  hasDowngradedBag: boolean;
  status: number;
  handleRefreshData(event: any): void;
}

class TrackingTimelineComponent extends React.Component<IProps, IState> {

  constructor(props: any) {
    super(props);
    this.state = {
      showDetails: false,
      hasDowngradedBag: props.hasDowngradedBag,
      timelineBaseClass: !props.hasDowngradedBag ? styles.timelineSuccess : styles.timelineError,
      timelineClasses: !props.hasDowngradedBag ? styles.timelineSuccess : styles.timelineError,
      language: props.language,
      statusGroups: [
        {
          name: 'Pick up',
          items: [
            {
              name: 'Pick up slot scheduled',
              active: false,
              completed: true
            },
            {
              name: 'Driver en route',
              active: true
            },
            {
              name: 'Pick up complete',
              active: false,
              completed: false
            }
          ]
        },
        {
          name: 'Processing',
          items: [
            {
              name: 'Delivered to warehouse',
              active: false,
              completed: false
            },
            {
              name: 'Bags X-rayed',
              active: false,
              completed: false
            },
            {
              name: 'Bags weighed',
              active: false,
              completed: false
            },
            {
              name: 'Ready for handover',
              active: false,
              completed: false
            }
          ]
        },
        {
          name: 'Handover',
          items: [
            {
              name: 'Bags handed over',
              active: false,
              completed: false
            }
          ]
        }
      ]
    };
  }

  handleToggleTimeline(e: any) {
    // this.setState(function (state, props) {
    //   return {
    //     showDetails: !state.showDetails
    //   }
    // });

    // this.setState(function (state, props) {
    //   return {
    //     timelineClasses: state.timelineBaseClass + ' ' + (state.showDetails ? styles.timelineOpen : styles.timelineClosed)
    //   }
    // });
  }

  public render() {


    // const listTimelineSteps = this.state.statusGroups.map(function(group, groupIndex) {
    //   return (
    //     <div className={styles.stepsGroup} key={groupIndex}>
    //       <h5>{group.name}</h5>
    //       {group.items.map(function(item, itemIndex) {
    //         return (
    //           <div className={item.completed ? styles.stepCompleted : item.active ? styles.stepActive : styles.step} key={itemIndex}>
    //             {item.name}
    //           </div>
    //         );
    //       })}
    //     </div>
    //   );
    // });

    const { language, multiLang } = this.props;

    return (
      <div className={this.state.timelineClasses}>
        <div className={styles.wrapper}>
          <div className={styles.overview}>
            <button className={styles.btn} onClick={e => this.handleToggleTimeline(e)}>
              <div className={styles.toggleIcons}>
                <i className={styles.icon}>timeline</i>
                <i className={styles.icon}>close</i>
              </div>
              <span className={styles.status}>
                {!this.state.hasDowngradedBag
                  ? this.props.status === 4 ? multiLang[`deliveredText${language}`]
                    : multiLang[`everythingOnTrackText${language}`]
                  : multiLang[`issueWithBagText${language}`]}
                {/* <i className={styles.icon}>chevron</i> */}
              </span>
            </button>
            <button className={styles.btnRefresh} onClick={(e) => this.props.handleRefreshData(e)}>
              <i className={styles.icon}>refresh</i>
            </button>
            <LanguageComponent selectedLanguage={this.props.languageCode}
              handleLanguageChange={this.props.handleLanguageChange} />
            <img className={styles.logo} src={logo} />
          </div>
          {/* <div className={styles.details}>
            {listTimelineSteps}
          </div> */}
        </div>
      </div>
    );
  }

}

export default TrackingTimelineComponent;



// WEBPACK FOOTER //
// ./src/components/tracking-timeline/tracking-timeline.component.tsx